import { spawn, call, takeLatest, put, all } from 'redux-saga/effects';

// Actions
import { sesionAction } from '../../../../application/actions/sesion';
import { loadersActions } from '../../../../application/actions/ui_loaders';
// import { logReqError } from '../../../ui/utils/functions';

import api from '../../../api';
const apiSesion = api(process.env.REACT_APP_URL);

export function* fetchSesion(trackId) {
  try {
 
    
    yield put(loadersActions.changeStatusLoaderSesion({ isLoading: true }));

    const { data } = yield call(apiSesion.post, '/sesion/redireccionar', ''  , { 
        'Track-Id': trackId.payload
     });

    yield put(loadersActions.changeStatusLoaderSesion({ isLoading: false }));

    if (data) {
    
      yield put(sesionAction.fetchSesionSuccess({ respuestaServicio: data }));

    } else {
      yield put(sesionAction.fetchSesionError());

    }

  } catch {
      //Errores
    yield all([
      put(sesionAction.fetchSesionError())
    ]);
  }
}

export function* watchFetchSesion() {
  yield takeLatest(sesionAction.fetchSesion.type, fetchSesion);
}

export default function* rootSaga() {
  yield spawn(watchFetchSesion);
}
